import React from 'react';
import { SiteContent } from '../data/content';

interface CapabilitiesProps {
  content: SiteContent['capabilities'];
}

export const Capabilities: React.FC<CapabilitiesProps> = ({ content }) => {
  return (
    <section className="capabilities-section" id="capabilities" aria-labelledby="cap-title">
      <div className="container">
        <div className="section-head">
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 id="cap-title" className="section-title">
            {content.title} <em>{content.titleEmphasis}</em>
          </h2>
        </div>

        <div className="capabilities-editorial-grid">
          {content.items.map((item) => (
            <article key={item.id} className="capability-editorial-card">
              <span className="card-index-mono">{item.index}</span>
              <h3 className="capability-title">{item.title}</h3>
              <p className="capability-desc">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
